import {Pipe, PipeTransform} from '@angular/core';
import {AuthorisationService} from '../services/auth/authorisation.service';
import {Features} from '../services/auth/features';

@Pipe({
    name: 'hasFeature'
})
export class HasFeaturePipe implements PipeTransform {

    transform(value: Features | Features[], obj?: object): unknown {
        if (typeof value === 'object') {
            return AuthorisationService.hasAnyFeature(value, obj);
        } else {
            return AuthorisationService.hasFeature(value, obj);
        }
    }
}
